import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const COLORS = {
  Active: "#3B82F6",
  Planning: "#8B5CF6",
  Completed: "#22C55E",
  "On Hold": "#F59E0B",
  Cancelled: "#CBD5E1",
};

const ProjectStatusChart = ({
  projects = [],
}) => {

  const statuses = [
    "Active",
    "Planning",
    "Completed",
    "On Hold",
    "Cancelled",
  ];

  const data = statuses.map(
    (status) => ({
      name: status,
      value: projects.filter(
        (project) =>
          project.status === status
      ).length,
      color: COLORS[status],
    })
  );

  const visibleData = data.filter(
    (item) => item.value > 0
  );

  const totalProjects =
    projects.length;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">

      {/* Header */}

      <div className="flex items-center justify-between">

        <div>

          <h3 className="font-semibold text-slate-800">
            Project Status
          </h3>

          <p className="text-xs text-slate-500">
            Overall project distribution
          </p>

        </div>

      </div>

      {/* Chart */}

      <div className="flex h-56 items-center gap-4">

        {totalProjects === 0 ? (

          <div className="w-full text-center text-sm text-slate-500">
            No projects available
          </div>

        ) : (

          <>
            {/* Donut */}

            <div className="relative h-28 w-28 flex-shrink-0">

              <ResponsiveContainer
                width="100%"
                height="100%"
              >
                <PieChart>

                  <Pie
                    data={visibleData}
                    dataKey="value"
                    innerRadius={30}
                    outerRadius={44}
                    paddingAngle={2}
                    stroke="none"
                  >

                    {visibleData.map(
                      (item) => (
                        <Cell
                          key={item.name}
                          fill={item.color}
                        />
                      )
                    )}

                  </Pie>

                  <Tooltip />

                </PieChart>
              </ResponsiveContainer>

              <div className="absolute inset-0 flex flex-col items-center justify-center">

                <h2 className="text-xl font-bold text-slate-800">
                  {totalProjects}
                </h2>

                <span className="text-[11px] text-slate-500">
                  Projects
                </span>

              </div>

            </div>

            {/* Legend */}

            <div className="flex-1 space-y-2">

              {data.map((item) => {

                const percent =
                  totalProjects > 0
                    ? Math.round(
                        (item.value /
                          totalProjects) *
                          100
                      )
                    : 0;

                return (
                  <div key={item.name}>

                    <div className="mb-1 flex items-center justify-between">

                      <div className="flex items-center gap-2">

                        <span
                          className="h-2.5 w-2.5 rounded-full"
                          style={{
                            backgroundColor:
                              item.color,
                          }}
                        />

                        <span className="text-xs font-medium text-slate-700">
                          {item.name}
                        </span>

                      </div>

                      <span className="text-xs font-semibold text-slate-700">
                        {item.value}
                      </span>

                    </div>

                    <div className="h-1.5 w-full rounded-full bg-slate-100">

                      <div
                        className="h-1.5 rounded-full"
                        style={{
                          width: `${percent}%`,
                          backgroundColor:
                            item.color,
                        }}
                      />

                    </div>

                  </div>
                );
              })}

            </div>
          </>
        )}

      </div>

    </div>
  );
};

export default ProjectStatusChart;